<template>
  <form-layout :label="label">
    <div class="col-md-9">
      <read-only-input :value="getText" />
    </div>
  </form-layout>
</template>

<script>
import ReadOnlyInput from "@/views/atoms/inputs/ReadOnlyInput";
import FormLayout from "@/views/templates/FormLayout";

export default {
  name: "SelectBrowseItem",
  components: {FormLayout, ReadOnlyInput},
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, null],
      required: true,
    },
    options: {
      type: Array,
      default: () => {
        return [
          {value: 1, text: 'aaa'},
          {value: 2, text: 'bbb'},
          {value: 3, text: 'ccc'},
        ]
      },
    },
    valueKey: {
      type: String,
      default: 'value',
    },
    textKey: {
      type: String,
      default: 'text',
    },
  },
  computed: {
    getText() {
      return this.options.find(e => e[this.valueKey] === this.value)?.[this.textKey] ?? '';
    }
  },

}
</script>
